import { Method, ROUTES } from "../../configuration/Configuration";
import { fetchAPI } from "../../configuration/MainService";

export class WSMigration {
  private static instnace: WSMigration;

  public static getInstance() {
    if (!this.instnace) {
      this.instnace = new WSMigration();
    }
    return this.instnace;
  }

  async runMigration(json: string, storeId: string): Promise<void> {
    try {
      const url = `${ROUTES.MIGRATION}${ROUTES.MIGRATION_PRODUCTS}${storeId}`;

      await fetchAPI({
        url,
        method: Method.POST,
        params: json,
        isAuthenticated: true,
      });
    } catch (error) {
      console.error("Migration failed:", error);
      throw error;
    }
  }
}
